export default "__VITE_ASSET__CipUd3pv__"